module.exports = {
  methods: {
    getReview: async function (id) {
      let response = await this.$axios.get("/review", {
        params: {
          id: id,
        },
      });
      return response.data;
    },
  },
};
